import { arrayOf, objectOf, shape, string } from 'prop-types'

export const GALLERY_SHAPE = shape({
  order: arrayOf(string),
  heroImage: string,
})

export const GALLERIES_SHAPE = shape({
  property: GALLERY_SHAPE,
  rooms: objectOf(GALLERY_SHAPE),
})
